import { ApiGetRequest, ApiPostRequest } from '../../../api';
import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Setting Saldo Awal',
    periode: {},
    kurs_mata_uang: []
  },
};

export const getters = {
  periode(state) {
    return state.data.periode;
  }
};

export const mutations = {
  changeTutupBulanan(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async prosesTutupBulanan({ commit, dispatch, state }) {
    commit('changeTutupBulanan', {
      loading: true,
    });

    const { data } = state;

    let result = await ApiPostRequest(`fin/tutup-buku/bulanan`, {
      kurs_mata_uang: data.kurs_mata_uang
    });
    
    commit('changeTutupBulanan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return true;
    }

    return false;
  },

  async getPeriodeTutupBulanan({ commit }) {
    commit('changeTutupBulanan', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/tutup-buku/periode`);
    commit('changeTutupBulanan', {
      loading: false,
    });

    if (!result.error) {
      commit('changeTutupBulanan', {
        periode: result.data.object
      })

      return true;
    }

    return false;
  },

  async getKursMataUang({ commit }) {
    commit('changeTutupBulanan', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/tutup-buku/kurs-mata-uang`);
    commit('changeTutupBulanan', {
      loading: false,
    });

    if (!result.error) {
      commit('changeTutupBulanan', {
        kurs_mata_uang: result.data.object
      })

      return true;
    }

    return false;
  },
};
